export class Wischnavigation {


	xDown : number | null = null;														
	yDown : number | null = null;
	element : Element;
	touchstartEvt : any | null;

	constructor(element : Element | undefined) {
		if (element == undefined || element == null)
			return;
		this.xDown = null;
		this.yDown = null;
		this.element = element;
		this.touchstartEvt =  null;

		this.element.addEventListener('touchstart', function(evt : any) {
			this.xDown = evt.touches[0].clientX;
			this.yDown = evt.touches[0].clientY;
			this.touchstartEvt = evt;
			
			if (this.xDown != null && this.xDown < 10) {
				evt.preventDefault();
				evt.stopPropagation();
			}			
		}.bind(this), false);
		
		
/*		
		this.element.addEventListener('touchmove', function(evt : any) {
			if (!this.xDown || !this.yDown) {
				return;
			}
	
			let xUp : number = evt.touches[0].clientX;
			let yUp : number = evt.touches[0].clientY;
	
			let xDiff : number = this.xDown - xUp;
			let yDiff : number = this.yDown - yUp;

	
			if (Math.abs(xDiff) > Math.abs(yDiff) ) { // Most significant.
				if (xDiff > 0 ) {
					this.onLeft();
				} else {
					this.onRight(evt);
				}
			} else {
				if (yDiff > 0 ) {
					this.onUp();
				} else {
					this.onDown();
				}
			}
	
			// Reset values.
			this.xDown = null;
			this.yDown = null;
		}.bind(this), false);
*/
	}


	onLeft() {
	}

	onRight(evt : any) : void {
		if (this.xDown != null && this.xDown < 10) {
			evt.preventDefault();
			evt.stopPropagation();
			if (this.touchstartEvt != null) {
				this.touchstartEvt.preventDefault();
				this.touchstartEvt.stopPropagation();
			}
		}
	}

	onUp() {
	}

	onDown() {
	}







	public static iosPreventSafariDefaultnav() {
		new Wischnavigation(document.body);
		new Wischnavigation(document.getElementById('ion-app-wrapper'));
		let elements : HTMLCollectionOf<Element> = document.getElementsByClassName("scroll-content");
		let i : number;
		for (i = 0; i < elements.length; i++) {
			new Wischnavigation(elements[i]);
		}
		elements = document.getElementsByClassName("app-root");
		for (i = 0; i < elements.length; i++) {
			new Wischnavigation(elements[i]);
		} 
		elements = document.getElementsByClassName("ion-page");
		for (i = 0; i < elements.length; i++) {
			new Wischnavigation(elements[i]);
		}
/*
		elements = document.getElementsByClassName("ion-nav-class");
		for (i = 0; i < elements.length; i++) {
			new Wischnavigation(elements[i]);
		}
*/
		elements = document.getElementsByClassName("content");
		for (i = 0; i < elements.length; i++) {
			new Wischnavigation(elements[i]);
		}
		elements = document.getElementsByClassName("fixed-content");
		for (i = 0; i < elements.length; i++) {
			new Wischnavigation(elements[i]);
		}
		elements = document.getElementsByClassName("click-block");
		for (i = 0; i < elements.length; i++) {
			new Wischnavigation(elements[i]);
		}
		elements = document.getElementsByClassName("inner-content");
		for (i = 0; i < elements.length; i++) {
			new Wischnavigation(elements[i]);
		}
		elements = document.getElementsByTagName("html");
		for (i = 0; i < elements.length; i++) {
			new Wischnavigation(elements[i]);
		}

	}

}


// WEBPACK FOOTER //
// ./src/Wischnavigation.ts